<template>
    <div class="card mb-0">
        <div class="card-content">
            <div class="card-body">
                <h4>Savol turi: Ko`p tanlovli</h4>
                <h4 class="d-flex align-items-center">
                    Savol: <span v-html="question.question" style="margin-top: 13px; margin-left: 8px;"></span>
                </h4>
                <h4>Балл: {{ question.ball }}</h4>
                <ul class="list-group mb-1">
                    <li class="list-group-item py-0" v-for="(answer, index) in answers">
                        <div class="d-flex align-items-center">
                            <div>
                                <div class="vs-checkbox-con vs-checkbox-primary">
                                    <input type="checkbox" :checked="answer.key" disabled="disabled" :id="'id-'+index">
                                    <span class="vs-checkbox">
                                                                <span class="vs-checkbox--check">
                                                                    <i class="vs-icon feather icon-check" style="top: 0; font-size: 1rem;" />
                                                                </span>
                                                            </span>
                                    <span :for="'id'+index" v-html="answer.answer" class="pt-1"></span>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <button class="btn btn-outline-info waves-effect waves-light" data-dismiss="modal">
                    Назад
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MultipleSelectionModal",
        props: {
            question: Object,
            answers: Array
        },
        methods:{
        },
    }
</script>

<style scoped>

</style>